var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-modal', {
    attrs: {
      "title": "Import Data",
      "ok-title": "Submit",
      "loading": _vm.loadingImport
    },
    on: {
      "ok": _vm.handleImport
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "text-primary"
        }, [_vm._v("Import Data")]), _c('i', {
          staticClass: "fa fa-times cursor-pointer",
          on: {
            "click": function click($event) {
              _vm.showModal = false;
            }
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showModal,
      callback: function callback($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [[_c('div', {
    staticClass: "flex flex-column align-items-center"
  }, [_c('b-form-file', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": ".xlsx, .xls, .csv"
    },
    model: {
      value: _vm.importFile,
      callback: function callback($$v) {
        _vm.importFile = $$v;
      },
      expression: "importFile"
    }
  }), _c('small', {
    staticClass: "text-black"
  }, [_vm._v("accept: .xlsx, .xls, .csv")])], 1), !_vm.loadingExportTemplate ? _c('b-button', {
    staticClass: "mt-3 w-100",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.handleExportTemplate
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download Template ")]) : _c('b-button', {
    staticClass: "mt-3 w-100",
    attrs: {
      "variant": "outline-primary"
    }
  }, [_c('b-spinner', {
    staticClass: "mr-2",
    staticStyle: {
      "width": "18px",
      "height": "18px"
    }
  }), _vm._v(" Downloading ")], 1)]], 2), _c('b-modal', {
    attrs: {
      "title": "Import Result",
      "size": "xl",
      "hide-footer": ""
    },
    model: {
      value: _vm.modalResponseImport,
      callback: function callback($$v) {
        _vm.modalResponseImport = $$v;
      },
      expression: "modalResponseImport"
    }
  }, [_c('ImportResultRh', {
    attrs: {
      "response": _vm.dataResponseImport
    }
  })], 1), _c('custom-sidebar', {
    attrs: {
      "size": "xl",
      "title": _vm.selectedData ? 'Edit Adjustment GOH' : 'Add Adjustment GOH'
    },
    model: {
      value: _vm.showCanvas,
      callback: function callback($$v) {
        _vm.showCanvas = $$v;
      },
      expression: "showCanvas"
    }
  }, [_c('div', {
    staticClass: "p-4 bg-white shadow-sm"
  }, [_c('FormGoh', {
    attrs: {
      "selectedData": _vm.selectedData
    },
    on: {
      "refetch": function refetch() {
        _vm.fetchData();
        _vm.showCanvas = false;
      }
    }
  })], 1)]), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("ADJUSTMENT KICK OFF GOH")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$rhData$data, _vm$rhData$data2;
        return [_c('b-row', [_c('FilterRh', {
          attrs: {
            "filters": _vm.filters
          }
        }), _c('b-col', {
          staticClass: "d-flex justify-content-end",
          attrs: {
            "lg": "6"
          }
        }, [_c('b-button', {
          staticClass: "d-flex align-items-center mx-2",
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              _vm.showModal = true;
            }
          }
        }, [_c('i', {
          staticClass: "ri-download-2-line pl-1"
        }), _vm._v(" Import ")]), _c('b-button', {
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              _vm.showCanvas = true;
              _vm.selectedData = null;
            }
          }
        }, [_vm._v(" Create Adjustment Kick Off GOH ")])], 1), !_vm.loading ? [(_vm$rhData$data = _vm.rhData.data) !== null && _vm$rhData$data !== void 0 && _vm$rhData$data.length ? _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('div', {
          staticClass: "overflow-auto",
          staticStyle: {
            "position": "relative"
          }
        }, [_c('table', {
          staticClass: "w-100 table-striped table-bordered table-hover"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-center",
          staticStyle: {
            "min-width": "60px"
          }
        }, [_vm._v("NO")]), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "min-width": "150px"
          }
        }, [_vm._v(" FLEET ")]), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "min-width": "180px"
          }
        }, [_vm._v(" ENGINE NAME ")]), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "min-width": "220px"
          }
        }, [_vm._v(" ENGINE SERIES ")]), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "min-width": "150px"
          }
        }, [_vm._v(" EFFECTIVE DATE ")]), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "min-width": "120px"
          }
        }, [_vm._v(" KICK OFF GOH ")]), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "min-width": "150px"
          }
        }, [_vm._v(" CREATED BY ")]), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "min-width": "200px"
          }
        }, [_vm._v(" REMARKS ")]), _c('th', {
          staticClass: "text-center",
          staticStyle: {
            "min-width": "120px"
          }
        }, [_vm._v(" ACTION ")])])]), _c('tbody', _vm._l(_vm.rhData.data, function (item, index) {
          var _item$vehicle, _item$power_type, _item$power_series, _item$power_series2, _item$creator, _item$creator$detail, _item$creator2, _item$creator2$detail;
          return _c('tr', {
            key: item.id
          }, [_c('td', {
            staticClass: "text-center"
          }, [_vm._v(" " + _vm._s((_vm.rhData.params.page - 1) * _vm.rhData.params.limit + index + 1) + " ")]), _c('td', [_c('strong', [_vm._v(_vm._s(((_item$vehicle = item.vehicle) === null || _item$vehicle === void 0 ? void 0 : _item$vehicle.name) || '-'))])]), _c('td', [_vm._v(_vm._s(((_item$power_type = item.power_type) === null || _item$power_type === void 0 ? void 0 : _item$power_type.name) || '-'))]), _c('td', [_c('div', [_c('strong', [_vm._v(_vm._s(((_item$power_series = item.power_series) === null || _item$power_series === void 0 ? void 0 : _item$power_series.name) || '-'))])]), _c('small', [_vm._v(_vm._s(((_item$power_series2 = item.power_series) === null || _item$power_series2 === void 0 ? void 0 : _item$power_series2.model) || '-'))])]), _c('td', {
            staticClass: "text-center"
          }, [_vm._v(" " + _vm._s(_vm.moment(item.effective_date).format('DD MMM YYYY')) + " ")]), _c('td', {
            staticClass: "text-center"
          }, [_c('span', {
            staticClass: "badge badge-info"
          }, [_vm._v(" " + _vm._s(_vm.formatNumber(item.kick_off_goh)) + " hrs ")])]), _c('td', [_c('div', {
            staticClass: "d-flex align-items-center"
          }, [_c('img', {
            staticStyle: {
              "width": "30px",
              "height": "30px",
              "border-radius": "50%",
              "margin-right": "8px"
            },
            attrs: {
              "src": _vm.getPhotoSrc(item.creator),
              "alt": (_item$creator = item.creator) === null || _item$creator === void 0 ? void 0 : (_item$creator$detail = _item$creator.detail) === null || _item$creator$detail === void 0 ? void 0 : _item$creator$detail.name
            },
            on: {
              "error": function error(evt) {
                return _vm.onPhotoError(evt, item.creator);
              }
            }
          }), _c('div', [_c('strong', {
            staticStyle: {
              "font-size": "12px"
            }
          }, [_vm._v(" " + _vm._s(((_item$creator2 = item.creator) === null || _item$creator2 === void 0 ? void 0 : (_item$creator2$detail = _item$creator2.detail) === null || _item$creator2$detail === void 0 ? void 0 : _item$creator2$detail.name) || '-') + " ")]), _c('br'), _c('small', {
            staticStyle: {
              "font-size": "10px"
            }
          }, [_vm._v(" " + _vm._s(_vm.moment(item.created_at).format('DD MMM YYYY')) + " ")])])])]), _c('td', [_vm._v(_vm._s(item.remarks || '-'))]), _c('td', {
            staticClass: "text-center"
          }, [_c('b-button-group', {
            attrs: {
              "size": "sm"
            }
          }, [_c('b-button', {
            attrs: {
              "variant": "outline-primary",
              "size": "sm",
              "title": "Edit"
            },
            on: {
              "click": function click($event) {
                return _vm.handleEdit(item);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-edit"
          })]), _c('b-button', {
            attrs: {
              "variant": "outline-danger",
              "size": "sm",
              "title": "Delete"
            },
            on: {
              "click": function click($event) {
                return _vm.handleDelete(item);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-trash"
          })])], 1)], 1)]);
        }), 0)])]), _c('div', {
          staticClass: "mt-4 d-flex align-items-center w-100 justify-content-between"
        }, [_c('p', {
          staticClass: "mb-0"
        }, [_vm._v(" Total Rows: "), _c('strong', {
          staticClass: "text-black"
        }, [_vm._v(_vm._s(_vm.rhData.params.total))])]), _c('div', {
          staticClass: "d-flex justify-content-end"
        }, [_c('b-pagination', {
          staticClass: "mb-0 mr-3",
          attrs: {
            "total-rows": _vm.rhData.params.total,
            "per-page": _vm.rhData.params.limit,
            "first-number": "",
            "align": "center"
          },
          on: {
            "change": function change(page) {
              _vm.rhData.params.page = page;
              _vm.fetchData();
            }
          },
          model: {
            value: _vm.rhData.params.page,
            callback: function callback($$v) {
              _vm.$set(_vm.rhData.params, "page", $$v);
            },
            expression: "rhData.params.page"
          }
        }), _c('b-form-select', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "plain": "",
            "options": _vm.limitOptions
          },
          on: {
            "input": _vm.fetchData
          },
          model: {
            value: _vm.rhData.params.limit,
            callback: function callback($$v) {
              _vm.$set(_vm.rhData.params, "limit", $$v);
            },
            expression: "rhData.params.limit"
          }
        })], 1)])]) : _vm._e()] : [_c('div', {
          staticClass: "w-100 d-flex justify-content-center align-items-center my-5 py-5"
        }, [_c('b-spinner')], 1)], !((_vm$rhData$data2 = _vm.rhData.data) !== null && _vm$rhData$data2 !== void 0 && _vm$rhData$data2.length) && !_vm.loading ? [_c('b-col', {
          attrs: {
            "cols": "12"
          }
        }, [_vm._v("No Data Here!")])] : _vm._e()], 2)];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }